<template>
  <div
    class="prescription-print"
    style="margin: 0; padding: 25px 40px; background: #fff; width: 100%"
  >
    <div
      class="header"
      style="
        width: 100%;
        padding: 0 0 12px 0;
        position: relative;
        display: flex;
        justify-content: space-between;
      "
    >
      <div class="header-left" style="width: 50%">
        <img
          src="https://genamet-static-uploads-prod.s3.ap-south-1.amazonaws.com/9081555f-68f9-4d4d-835f-824d6a435dd9/images/logo/064d5b75-bea2-4715-a9d7-0429629b0455.png"
          style="max-width: 120px"
        />
      </div>
      <div class="header-right" hidden style="width: 50%; text-align: right">
        <img src="" />
        <span></span>
        <p></p>
        <span><input type="checkbox" />Show Header</span>
      </div>
    </div>
    <div class="patient-details" style="min-height: 90px">
      <table
        border="0 !important"
        cellspacing="0"
        cellpadding="0"
        style="
          font-size: 16px;
          width: 400px;
          margin-bottom: 20px;
          font-family: arial, sans-serif;
          border-collapse: collapse;
          border: 0 !important;
          table-layout: fixed;
        "
      >
        <tbody style="border: 0 !important">
          <tr style="background: none; border: 0 !important">
            <td
              style="
                padding: 2px 0;
                border: 0;
                text-align: left;
                border: 0 !important;
                font-family: 'Poppins', arial, sans-serif !important;
                font-size: 14px;
                line-height: 1.5;
              "
            >
              Patient name
            </td>
            <!-- <td style="padding: 2px 0; border: 0; text-align: left; border: 0 !important; font-family: 'Poppins', arial, sans-serif !important; font-size: 14px; line-height: 1.5;">: {{ patient.firstname + " " + patient.lastname }}</td> -->
            <td
              style="
                padding: 2px 0;
                border: 0;
                text-align: left;
                font-family: 'Poppins', arial, sans-serif !important;
                font-size: 14px;
                line-height: 1.5;
              "
            >
              :
              {{
                patient.firstname || patient.lastname
                  ? (patient.firstname || "") +
                    (patient.lastname ? " " + patient.lastname : "")
                  : patient.name
              }}
            </td>
          </tr>
          <tr style="background: none; border: 0 !important">
            <td
              style="
                padding: 2px 0;
                border: 0;
                text-align: left;
                border: 0 !important;
                font-family: 'Poppins', arial, sans-serif !important;
                font-size: 14px;
                line-height: 1.5;
              "
            >
              Registration No.
            </td>
            <td
              style="
                padding: 2px 0;
                border: 0;
                text-align: left;
                border: 0 !important;
                font-family: 'Poppins', arial, sans-serif !important;
                font-size: 14px;
                line-height: 1.5;
              "
            >
              : {{ patient.patient_RegId }}
            </td>
          </tr>
          <tr style="background: none; border: 0 !important">
            <td
              style="
                padding: 2px 0;
                border: 0;
                text-align: left;
                border: 0 !important;
                font-family: 'Poppins', arial, sans-serif !important;
                font-size: 14px;
                line-height: 1.5;
              "
            >
              Age / Sex
            </td>
            <td
              style="
                padding: 2px 0;
                border: 0;
                text-align: left;
                border: 0 !important;
                font-family: 'Poppins', arial, sans-serif !important;
                font-size: 14px;
                line-height: 1.5;
              "
            >
              : {{ displayAge }}y / {{ patient.gender }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rx-img" style="margin-bottom: 5px">
      <p style="padding: 10px 0">
        Date: <span style="font-weight: normal">{{ time }}</span>
      </p>
      <img src="@/static/images/rx.png" alt="" />
    </div>

    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="main-table"
      style="
        font-family: arial, sans-serif;
        font-size: 14px;
        border-collapse: collapse;
        border: 0 !important;
        border-bottom: 1px solid #000000 !important;
        table-layout: fixed;
        width: 760px;
      "
    >
      <thead style="border: 0 !important">
        <tr style="border: 0 !important">
          <th
            style="
              border: 0 !important;
              border-top: 1px solid #000000 !important;
              border-bottom: 1px solid #000000 !important;
              text-align: left;
              padding: 3px 15px;
            "
          >
            Medicine Name
          </th>
        </tr>
      </thead>
      <tbody style="border: 0 !important">
        <tr
          v-for="item in selectedItemsData"
          :key="item.itemId"
          style="border: 0 !important"
        >
          <td
            style="
              text-align: left;
              padding: 10px 20px;
              border: 0 !important;
              font-family: 'Poppins', arial, sans-serif !important;
              font-size: 14px;
              line-height: 1.5;
            "
          >
            <strong>{{ getItemName(item, "te") }}</strong>

            <span
              v-if="selectedLanguage && selectedLanguage !== 'te'"
              class="other-language-name"
            >
              ({{ getItemName(item, selectedLanguage) }})
            </span>

            <br />

            <div class="description-te">
              <p class="prescription-text">
                {{ getLanguageDesc(item, "te") }}
              </p>
            </div>

            <div
              v-if="selectedLanguage && selectedLanguage !== 'te'"
              class="description-other-lang"
            >
            <p class="prescription-text">
              {{ getLanguageDesc(item, selectedLanguage) }}
            </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table
      cellspacing="0"
      cellpadding="0"
      class="signature-table"
      style="
        font-family: arial, sans-serif;
        font-size: 14px;
        border-collapse: collapse;
        border: 0 !important;
        border-bottom: 1px solid #000000 !important;
        table-layout: fixed;
        width: 760px;
      "
    >
      <tbody style="border: 0 !important">
        <tr style="border: 0 !important">
          <td
            style="
              text-align: left;
              padding: 10px 20px;
              text-align: right;
              font-weight: bold;
              border: 0 !important;
              font-family: 'Poppins', arial, sans-serif !important;
              font-size: 14px;
              line-height: 1.5;
            "
          >
            {{ doctorName }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Prescription",
  props: {
    patient: {
      type: Object,
      required: true,
    },
    selectedItemsData: {
      type: Array,
      required: true,
      default: () => [],
    },
    logoUrl: {
      type: String,
      default: "Nandagokulam-logo.jpg",
    },
    time: {
      type: String,
      required: true,
    },
    selectedLanguage: {
      type: String,
      default: "te",
    },
    created_by: {
      type: String,
      default: "",
    },
    doctorName: {
      type: String,
      default: "",
    },
  },
  methods: {
    calculateAge(dobString) {
      if (!dobString) return 0;

      const [day, month, year] = dobString.split("-").map(Number);
      const dob = new Date(year, month - 1, day);
      const today = new Date();

      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
      }

      return age;
    },
    getItemName(item, lang) {
      const langEntry = item.languages.find((l) => l.languageCode === lang);
      return langEntry ? langEntry.name : "";
    },
    getLanguageDesc(item, lang) {
      const langEntry = item.languages.find((l) => l.languageCode === lang);
      return langEntry ? langEntry.description : "";
    },
  },
  computed: {
    displayAge() {
      if (this.patient.age && Number(this.patient.age) > 0) {
        return this.patient.age;
      } else {
        return this.calculateAge(this.patient.Date_of_birth);
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap");

table {
  font-size: 10px;
  border: 0 !important;
}

body {
  font-family: "Poppins", arial, sans-serif !important;
  color: #692529;
  background: #d4d4d7;
}

.prescription-print {
  margin: 0;
  padding: 25px 40px;
  background: #fff;
  width: 100%;
}

.header {
  width: 100%;
  padding: 0 0 12px 0;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.header-left {
  width: 50%;
}

.header-right {
  width: 50%;
  text-align: right;
}

.header-print {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  grid-gap: 15px;
}

.qr-code {
  margin-top: 20px;
  position: absolute;
  right: 0;
}

.qr-code img {
  max-width: 100px;
}

.patient-details {
  min-height: 90px;
}

.patient-details table {
  font-size: 16px;
  width: 400px;
  border: 0 !important;
  margin-bottom: 20px;
}

.patient-details table tr {
  background: none;
}

.patient-details table td {
  padding: 2px 0;
}

p {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.rx-img img {
  max-width: 32px;
}

table {
  font-family: arial, sans-serif;
  font-size: 14px;
  border-collapse: collapse;
  width: 100%;
  border-bottom: 1px solid #692529;
}

th {
  border-top: 1px solid #692529;
  border-bottom: 1px solid #692529;
  text-align: left;
  padding: 3px 15px;
}

td {
  border: 0;
  text-align: left;
  padding: 10px 20px;
}

table.main-table td {
  font-weight: bold;
}

tr:nth-child(even) {
  background-color: #fafafa;
}

table.signature-table td {
  text-align: right;
  font-weight: bold;
}
.prescription-text {
  white-space: pre-line;  
}

@media print {
  @page {
    size: A4; /* Sets the page size to A4 */
    margin: 0; /* Removes all default page margins */
  }
  html,
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
  }
  body {
    background-color: white;
    margin: 0;
    width: 100%;
  }
  table {
    border: 0 !important;
    border-bottom: 1px solid #000000 !important;
    width: 100%;
    table-layout: fixed;
  }
  tbody {
    border: 0 !important;
  }
  thead {
    border: 0 !important;
  }
  th {
    border: 0 !important;
    border-top: 1px solid #000000 !important;
    border-bottom: 1px solid #000000 !important;
  }
  tr {
    border: 0 !important;
  }
  td {
    border: 0 !important;
    font-family: "Poppins", arial, sans-serif !important;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>